import React from 'react';
import { CalendarCheckIcon, MessageSquareIcon, PhoneCallIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
const tiles: {
  label: string;
  icon: typeof PhoneCallIcon;
}[] = [{
  label: 'Missed calls answered live',
  icon: PhoneCallIcon
}, {
  label: 'Written leads answered in under 60 seconds',
  icon: MessageSquareIcon
}, {
  label: 'Booked, logged, and signed before the showing',
  icon: CalendarCheckIcon
}];
export function ValueStrip() {
  return <section aria-label="What the system does" className="border-b border-white/5 bg-ink-900" data-id="element-530" data-mp="32o5580qop1z9">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-20" data-id="element-531" data-mp="37nhsgmlgwb2d">
        <ul className="grid gap-4 md:grid-cols-3" data-id="element-532" data-mp="37ldpc6ve7g35">
          {tiles.map((tile, index) => {
          const Icon = tile.icon;
          return <li key={tile.label} className="h-full" data-id="element-533" data-mp="1da8o197s3fqz" data-mpi={index}>
                <Reveal delay={0.06 * index} className="h-full" data-id="element-534" data-mp="1i8a89xgxxl41">
                  <div className="flex h-full items-start gap-4 rounded-xl border border-white/10 bg-ink-800 p-6" data-id="element-535" data-mp="1i8tn35bantdu">
                    <Icon className="mt-0.5 h-5 w-5 flex-none text-brand" aria-hidden="true" data-id="element-536" data-mp="pg4cfnb34osn" />
                    <p className="font-display text-base font-semibold leading-snug text-white" data-id="element-537" data-mp="fp9nucad9d41">
                      {tile.label}
                    </p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}